import React from 'react'
import { TextField } from '@material-ui/core'
import InputMask from 'react-input-mask'

const MaskedTextInput = props => {
  return (
    <InputMask maskChar={''} {...props}>
      {inputProps => <TextField disabled={props?.disabled} {...inputProps} />}
    </InputMask>
  )
}

export default MaskedTextInput
